
import React from "react";
import { motion } from "framer-motion";

const HeroSection: React.FC = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="mb-12"
    >
      <div className="flex flex-col md:flex-row items-center gap-8">
        <div className="md:w-1/2 space-y-4">
          <h1 className="text-3xl font-playfair font-bold text-heaven-gold mb-4">
            Some say there is no God. You know there is.
          </h1>
          <p className="text-[#403E43]/80 mb-6 text-lg">
            Selah helps you explain why—with Scripture, reason, and love.
          </p>
          <div className="bg-heaven-gold/5 p-5 rounded-lg border border-heaven-gold/10 shadow-sm space-y-3">
            <p className="text-[#403E43]/80">
              Atheism questions everything—God's existence, absolute truth, and the very meaning of life. 
              Selah helps you respond with confidence rooted in Scripture, backed by logic and science, 
              and shaped by the heart of Jesus.
            </p>
            <p className="text-[#403E43]/80">
              This tool equips you to engage atheism, secular humanism, and moral relativism with answers 
              that are clear, thoughtful, and grounded in truth—not to win arguments, but to lead people toward the gospel.
            </p>
          </div>
        </div>
        <div className="md:w-1/2">
          <img 
            src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//ChatGPT%20Image%20Apr%203,%202025,%2010_15_55%20PM.png" 
            alt="Addressing Atheism" 
            className="rounded-lg shadow-md w-full h-auto object-cover object-center"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default HeroSection;
